module.exports = "pegasus/assets/blocks/column-16-theme2.png";